import { memo, useMemo } from "react";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setOrganisationSortColumn } from "@sso/store/slices/organisation";
import { Organisation } from "@sso/types";
import { LayoutTable, TableWrapper, TD, TH } from "@sso/ui/Table";

import { OrganisationsTableActions } from "./OrganisationTableActions";
import { organisationTableColumns } from "./organisationTableColumns";

interface OrganisationsTableProps {
  orgList: Organisation[];
}

export const OrganisationsTable = memo(({ orgList }: OrganisationsTableProps) => {
  const dispatch = useAppDispatch();

  const data: Organisation[] = useMemo(
    () =>
      orgList.map(org => ({
        ...org,
        lastLoginDate: org.lastLoginDate ? new Date(org.lastLoginDate).toLocaleDateString() : "-",
        creationDate: org.creationDate ? new Date(org.creationDate).toLocaleDateString() : "-",
      })),
    [orgList],
  );

  const handleSortAction = (column: string) => {
    dispatch(setOrganisationSortColumn(column));
  };

  return (
    <TableWrapper>
      <LayoutTable>
        <thead>
          <tr>
            {organisationTableColumns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
            <TH textAlign="center">Actions</TH>
          </tr>
        </thead>
        <tbody>
          {data.map(org => (
            <tr key={org.organisationId}>
              {organisationTableColumns.map(col => (
                <TD key={col.field}>{org[col.field]}</TD>
              ))}
              <OrganisationsTableActions org={org} />
            </tr>
          ))}
        </tbody>
      </LayoutTable>
    </TableWrapper>
  );
});
